/// <amd-module name="Wit/WorkItemModel/RuleEngine/FieldValidationKey" />
import { IFieldValidationKey, IWorkItemIdentityScope } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import { FilterByScope } from "./FilterByScope";

export class FieldValidationKey implements IFieldValidationKey {
    public fieldId: number;
    public fieldValue: any;
    public scope: IWorkItemIdentityScope;

    constructor(fieldId: number, fieldValue: any, scope: IWorkItemIdentityScope) {
        this.fieldId = fieldId;
        this.fieldValue = fieldValue;
        this.scope = scope;
    }

    public toString(): string {
        return JSON.stringify({
            fieldId: this.fieldId,
            fieldValue: this.fieldValue,
            scope: {
                filterByScope: FilterByScope.GetHashCode(this.scope),
                nonIdentities: this.scope && this.scope.nonIdentities,
                excludeGroups: this.scope && this.scope.excludeGroups
            }
        });
    }

    public equals(key: IFieldValidationKey): boolean {
        return key.toString() === this.toString();
    }
}
